import { render, staticRenderFns } from "./InvitesReceived.vue?vue&type=template&id=d39d0ac2&"
import script from "./InvitesReceived.vue?vue&type=script&lang=js&"
export * from "./InvitesReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports